import { BaseApi, ResponseEntity } from "@/utils/request";

export class BbsApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * List
   */
  public getBbsList(
    pageNum = 1,
    limit = 10,
    searchKey = "",
    orderColumn = "ID"
  ): Promise<ResponseEntity> {
    const data: object = {
      orderColunm: orderColumn,
      orderDir: "DESC",
      limit: limit,
      page: pageNum,
      "ContentTitle|LIKE|ContentTitle": searchKey,
    };
    return this.get("/Bbs/GetBbsList", data);
  }

  public getBbsDetail(id: number) {
    return this.get("/Bbs/GetBbsInfo", { id });
  }
  
  /**
   * 评论
   * @param id
   */
  public comment(
    id: number,
    comment: string,
    parentId = 0
  ): Promise<ResponseEntity> {
    return this.post("/Bbs/Comment", { id, comment, parentId });
  }
}
